import jwt_decode from "jwt-decode";
import {getUserFromToken} from "../helpers/UserToken";
import { axiosWrapper } from "../helpers/apiWrapper";

console.log("TOKEN IN SESSION:", sessionStorage.getItem("token"));
console.log("TOKEN token:", sessionStorage.getItem("token"));
export const defaultPermissions: any = {
    category: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
    order: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
    product: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
    role: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
    seller: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
    tax: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
    user: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
    location: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
    product_master_catalog: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
    igm: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
    transaction: { p_read: true, p_write: true, p_update: true, p_delete: true, read: true, write: true, update: true, delete: true },
};

export const tokenDecode = (tk_access?: any) => {
    try {
        if (tk_access) {
            sessionStorage.setItem("token", tk_access);
        }
        const token: any = sessionStorage.getItem("token");
        if (!token) return false;
        const decoded: any = jwt_decode(token);
        if (decoded && decoded.data) {
            if (!decoded.data.permission) {
                decoded.data.permission = defaultPermissions;
            }
            return decoded;
        }
        return decoded || false;
    } catch (error) {
        return false;
    }
}


export function checkKYCStatus() {
    let isVerfied = (getUserFromToken() as any)?.user?.kyc_status;
    if (isVerfied == false) {
        alert("Kindly complete your KYC..")
        return {
            isError: true,
            error: "KYC pending"
        }
    }
}

export async function createAnalyticsPayload(
    sellerId:any,
    sellerMobile:any,
    eventType:any,
    elementText:any,
    eventRoute:any,
    pageName:any,
    isApiCalled:any,
    reqPayload:any,
    eventResult:any,
    response:any,
    stepName:any
) {
    const now = new Date();

    let paylaod = {
        seller_id: sellerId,
        seller_mobile: sellerMobile,

        eventType: eventType,          // "Click" | "Input Change" | "Page Load"
        elementText: elementText,      // "Create Product", "Login"
        eventRoute: eventRoute,        // "/login", "/product"
        pageName: pageName,            // "login_page"

        is_apiCalled: isApiCalled,

        req_payload: reqPayload,
        event_result: eventResult,      // "success" | "fail"
        response,

        step_name: stepName,            // e.g. "aadhaar_verification"

        event_date: now.toLocaleDateString("en-GB"), // DD/MM/YYYY
        time: now.toLocaleTimeString("en-IN"), // HH:MM:SS am/pm
    }

    axiosWrapper.post("/api/analystics/log-event", paylaod)


}